import { c as _c } from "react/compiler-runtime";
import { getRoleMenuItemSx, RoleMenuItem } from "@components/role/role-menu-item";
import { MenuItem, UserRoleIcon } from "@flat-ui";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { useChangeMemberRole } from "@hooks/use-change-member-role";
import { FaroCoreApiConst } from "@stellar/core-api-client";
import { getAssignableWorkspaceRoles, getDisabledRoles } from "@utils/workspace-role-utils";
/**
 * Menu button that opens a role change sub-menu with assignable roles.
 * Uses the same MenuItem + RoleMenuItem pattern as the bulk action buttons.
 */
export function MemberRoleMenuButton(t0) {
  const $ = _c(26);
  const {
    member,
    companyId,
    subjectType,
    selectedProject,
    group,
    onMenuClose
  } = t0;
  let t1;
  if ($[0] !== companyId || $[1] !== group || $[2] !== member.identity || $[3] !== member.role || $[4] !== selectedProject || $[5] !== subjectType) {
    t1 = {
      companyId,
      subjectType,
      memberIdentity: member.identity,
      currentRole: member.role,
      selectedProject,
      group,
      location: "members-role-menu-button"
    };
    $[0] = companyId;
    $[1] = group;
    $[2] = member.identity;
    $[3] = member.role;
    $[4] = selectedProject;
    $[5] = subjectType;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const {
    changeMemberRole
  } = useChangeMemberRole(t1);
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  let T0;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[7] !== canAssignManagers || $[8] !== changeMemberRole || $[9] !== member.role || $[10] !== onMenuClose || $[11] !== subjectType) {
    const {
      roles,
      disabledRoles
    } = getAssignableRoles(subjectType, member.role, canAssignManagers);
    let t6;
    if ($[17] !== changeMemberRole || $[18] !== onMenuClose) {
      t6 = async function onRoleClicked(role) {
        try {
          await changeMemberRole(role);
        } catch {}
        onMenuClose();
      };
      $[17] = changeMemberRole;
      $[18] = onMenuClose;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    const onRoleClicked = t6;
    T0 = MenuItem;
    t2 = "Change role";
    t3 = UserRoleIcon;
    t4 = "click";
    t5 = roles.map(role_0 => <MenuItem key={role_0} value={role_0} disabled={disabledRoles.includes(role_0)} onClick={() => onRoleClicked(role_0)} sx={getRoleMenuItemSx({
      isTableCell: false
    })}><RoleMenuItem role={role_0} isRoleSelected={role_0 === member.role} /></MenuItem>);
    $[7] = canAssignManagers;
    $[8] = changeMemberRole;
    $[9] = member.role;
    $[10] = onMenuClose;
    $[11] = subjectType;
    $[12] = T0;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    T0 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
  }
  let t6;
  if ($[20] !== T0 || $[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5) {
    t6 = <T0 label={t2} Icon={t3} subMenuTrigger={t4}>{t5}</T0>;
    $[20] = T0;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
}
/** Returns the roles and disabled roles matching the table column dropdown */
function getAssignableRoles(subjectType, currentRole, canAssignManagers) {
  switch (subjectType) {
    case "project":
      return {
        roles: FaroCoreApiConst.allProjectRoles,
        disabledRoles: ["RESOURCE_OWNER"]
      };
    case "group":
      return {
        roles: FaroCoreApiConst.allGroupRoles,
        disabledRoles: []
      };
    case "workspace":
    case "team":
      return {
        roles: getAssignableWorkspaceRoles("change", canAssignManagers),
        disabledRoles: getDisabledRoles(currentRole)
      };
    default:
      return {
        roles: [],
        disabledRoles: []
      };
  }
}